import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';
import LeadsHeaderImage from '../../common/assets/LeadsHeadImage1.png';

interface StyledInputProps {
  isError: boolean;
}
const Kanit = 'Kanit, Helvetica Neue, Helvetica, Arial, sans-serif';
export const LeadsFormWrapper = styled.div`
  display: flex;
  border-radius: 16px;
  gap: 30px;
  border: 1px solid rgba(18, 129, 197, 0.7);
  @media (${mediaQuery.mobile}) {
    flex-direction: column;
    align-items: center;
  }
`;
export const LeadsFormHeader = styled.div`
  display: flex;
  min-height: 300px;
  gap: 30px;
  justify-content: center;
  width: 100%;
  @media (${mediaQuery.mobile}) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export const LeadsFormHead = styled.div`
  flex-basis: 40%;
  background: rgba(18, 129, 197, 0.7);
  display: flex;
  flex-direction: column;
  gap: 25px;
  border-radius: 16px 0px 0px 16px;
  background-image: url(${LeadsHeaderImage});
  background-size: cover;
  background-position: center;
  @media (${mediaQuery.mobile}) {
    background: none;
    border-radius: 16px 0px 0px 16px;
  }
`;
export const LeadsFormImages = styled.div`
  @media (${mediaQuery.mobile}) {
    padding: 0px;
    width: 100%;
    height: auto;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;
export const FormSubmittedImage = styled.img`
  width: 47px;
  height: 48px;
  cursor: pointer;
`;
export const LeadsFormHeaderImage = styled.img`
  cursor: pointer;
  display: none;
  @media (${mediaQuery.mobile}) {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 16px 16px 0px 0px;
  }
`;
export const LeadsFormTitle = styled.div`
  font-size: 23px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  padding: 0px 20px;
  font-family: ${Kanit};
  @media (${mediaQuery.mobile}) {
    color: #000000;
  }
`;
export const LeadsFormSubtitle = styled.div`
  font-size: 15px;
  line-height: 20px;
  font-family: ${Kanit};
  font-weight: 300;
  padding: 0px 20px;
  color: #000000;
  @media (${mediaQuery.mobile}) {
    color: #000000;
  }
`;

export const LeadsFormContainer = styled.div`
  max-width: 400px;
  margin: 20px auto;
  @media (${mediaQuery.mobile}) {
    margin: 0px auto 15px;
  }
`;
export const LeadsForm = styled.div`
  display: flex;
  flex-direction: column;
  @media (${mediaQuery.mobile}) {
    padding: 0 33px;
  }
`;
export const FormField = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
`;
export const StyledLabel = styled.label`
  margin-bottom: 5px;
  font-size: 16px;
  font-family: ${Kanit};
  line-height: 24px;
  font-weight: 400;
`;
export const StyledInput = styled.input<StyledInputProps>`
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-right: 20px;
  width: 350px;
  font-family: ${Kanit};
  border: 1px solid
    ${({ isError }: { isError: boolean }) => (isError ? 'red' : '#ccc')};
  &::placeholder {
    font-size: 12px;
  }
  @media (${mediaQuery.mobile}) {
    width: 330px;
  }
`;
export const CheckboxInput = styled.input<StyledInputProps>`
  display: inline-block;
  margin-left: 5px;
  font-size: 16px;
  margin-right: 10px;
  transform: scale(1.7);
  margin-top: 5px;
  outline: 1px auto ${({ isError }) => (isError ? '#f29696' : '#faf9f9')};
`;
export const CheckboxLabel = styled.label`
  font-size: 12px;
  line-height: 16px;
  font-family: ${Kanit};
  font-weight: 300;
  color: #656565;
  width: 320px;
`;
export const FormFieldCheckbox = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
`;
export const Button = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  background-color: #c20014;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 20px;
  width: 350px;
  margin-bottom: 20px;
  font-family: ${Kanit};
  &:hover {
    background-color: #a20717;
  }
  &:disabled {
    background-color: #a20717;
    cursor: not-allowed;
  }
  @media (${mediaQuery.mobile}) {
    width: 330px;
  }
`;
export const LabelHighlight = styled.span`
  color: #1281c5;
`;
export const ErrorMessage = styled.div`
  color: red;
  font-size: 10px;
  margin-top: 5px;
  font-family: ${Kanit};
`;
export const LeadsFormContent = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  @media (${mediaQuery.mobile}) {
    padding: 20px;
    margin-left: 0px;
    gap: 7px;
  }
`;

export const ContentTitle = styled.div`
  font-size: 1.2rem;
  color: #3e3e4b;
  font-family: ${Kanit};
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  color: #333f48;
  @media (${mediaQuery.mobile}) {
    font-size: 1rem;
  }
`;
export const ContentSubTitle = styled.p`
  @media (${mediaQuery.mobile}) {
    font-size: 12px;
    width: 300px;
  }
`;
export const CloseIconWrapper = styled.span`
  position: relative;
  top: 15px;
  right: 0px;
  left: -30px;
  font-family: ${Kanit};
  font-size: 25px;
  cursor: pointer;
`;
export const LeadsFormSubmittedContainer = styled.div`
  display: flex;
  border: 1px solid rgba(18, 129, 197, 0.7);
  border-radius: 16px;
`;
